'use client'
import { useSyncExternalStore } from 'react'

const subscribe = () => () => {}

export const useMount = (): boolean => {
  return useSyncExternalStore(
    subscribe,
    () => true,  // Client-side: always return true
    () => false  // Server-side: always return false
  )
}
